'use strict';

angular.module('controllers').controller('usersCtrl', function (resources, $scope, ROLES, $window) {
		$window.document.title = 'Admin - Users';
	});

